<template>
    <div>
        <hts-form-select
            v-model="cValue"
            v-model:text="cText"
            :query="findCommodity"
            :disabled="disabled"
            :readonly="readonly"
            :filterable="true"
            :clearable="true"
            :creatable="CCreatable"
            :label="$t('labels.commodity')"
            :required="required"
            :multiple="multiple"
            :prop="prop"
            :selected-multiple="dataSelectMultiple"
            key-id="_id"
            key-label="commodity"
            :param-prepare="paramPrepare"
            @create-new="openAddCommodity" />
        <add-commodity
            ref="addCommodity"
            @newCommodity="handleChangeCreateCommodity" />
    </div>
</template>

<script lang="ts" setup>
import layoutPermissions from '@/data/permissions/layout-permissions'
import { checkPermission } from '@/utils/permission-check'
import AddCommodity from '../../pages/trucker-[id]/partner/[idpartner]/commodity/-components/add-commodity.vue'

const props = defineProps({
  modelValue: { type: [Array, String], default: () => '' },
  dataSelectMultiple: { type: Array, default: () => [] },
  prop: { type: String },
  multiple: { type: Boolean, default: false },
  required: { type: Boolean, default: false },
  creatable: { type: Boolean, default: false },
  cooperatorId: { type: String, default: '' },
  opportunityId: { type: String, default: '' },
  name: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  functionCreateNew: { type: Function, default: null },
  paramPrepare: { type: String, default: '' }
})

const { modelValue, cooperatorId, opportunityId, creatable, functionCreateNew, name, multiple, disabled, readonly } = toRefs(props)
const emits = defineEmits(['update:modelValue', 'update:name', 'click', 'change'])

const CCreatable = computed(() => {
  if (!creatable?.value) {
    return false
  }
  if (!checkPermission(layoutPermissions.partner_commodity_add)) {
    return false
  }
  return true
})

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    if (disabled.value || readonly.value) {
      return
    }
    emits('update:modelValue', val)
  }
})
const cText = computed({
  get () {
    return name.value || ''
  },
  set (val: any) {
    if (disabled.value || readonly.value) {
      return
    }
    emits('update:name', val)
  }
})
const findCommodity = async (s: string) => {
  if (!cooperatorId.value || !opportunityId.value) {
    return null
  }
  const api = $url.commodity.commodity.findByOpportunity
  const res = await $api(api, { uriParams: { KEY: s, COOPERATOR: cooperatorId.value, OPPORTUNITY: opportunityId.value } })
  const resData: any = res?.data.value
  if (resData?.success) {
    return resData.data
  }
  return null
}
// const handleAddCommodity = () => {
//   if (creatable && functionCreateNew.value && typeof functionCreateNew.value === 'function') {
//     functionCreateNew.value()
//   }
// }

const addCommodity = ref()
const openAddCommodity = () => {
  if (addCommodity.value) {
    addCommodity.value.open(cooperatorId.value, opportunityId.value)
  }
}

const handleChangeCreateCommodity = (data: any) => {
  if (disabled.value || readonly.value) {
    return
  }
  if (!multiple.value) {
    if (data && data._id) {
      cValue.value = data._id
      cText.value = data.commodity || ''
    }
  }
}

watch(
  () => opportunityId.value,
  () => {
    if (disabled.value || readonly.value) {
      return
    }
    if (!opportunityId.value) {
      emits('update:modelValue', '')
      emits('update:name', '')
      emits('change', [])
    }
  }
)
</script>
